/**
 * - Description -
 * TimeService is a helper class that provides some facilities to handle the timing and so on.
 *
 * - Usage -
 * Using TimeService
 *
 * import TimeService from '@/helpers/TimeService.js'
 *
 */
let timingDetails = {};


export default {
    name: 'TimeService',
    getXDayFromToday: getXDayFromToday,
    parseDate: parseDate,
    getCurrentTimeInHoursAndMinutes: getCurrentTimeInHoursAndMinutes,
    secondsToMillis: secondsToMillis,
    millisToSeconds: millisToSeconds,
    startTiming: startTiming,
    endTiming: endTiming,

}

function getXDayFromToday(daysToMove) {
    let now = new Date();
    now.setDate(now.getDate() + daysToMove);
    return now.toISOString().substr(0, 10);
}

function parseDate(date) {
    let hours = getHours(date);
    let minutes = getMinutes(date);
    let dayName = getDayName(date);
    let day = getDay(date);
    let month = getMonth(date);
    let year = date.getFullYear();
    return dayName + " " + day + "/" + month + "/" + year + " - " + hours + ":" + minutes;
}

function getCurrentTimeInHoursAndMinutes() {
    let date = new Date();
    let hours = getHours(date);
    let minutes = getMinutes(date);
    return hours + ":" + minutes;
}

function secondsToMillis(seconds) {
    return seconds * 1000;
}

function millisToSeconds(millis) {
    return millis / 1000;
}

function getDayName(date) {
    let day = date.getDay();
    let days = ["Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Mon"];
    return days[day];
}

function getDay(date) {
    let day = date.getDate();
    if (day < 10) {
        day = "0" + day;
    }
    return day;
}

function getMonth(date) {
    let month = date.getMonth();
    if (month < 10) {
        month = "0" + month;
    }
    return month;
}

function getHours(date) {
    let hours = date.getHours();
    if (hours < 10) {
        hours = "0" + hours;
    }
    return hours;
}

function getMinutes(date) {
    let minutes = date.getMinutes();
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    return minutes;
}

function startTiming(id) {
    timingDetails[id] = {
        start: performance.now(),
    };
}

function endTiming(id) {
    if (timingDetails[id] !== undefined) {
        timingDetails[id].end = performance.now();
        console.debug("TIMING - Time used by function with id <" + id + "> is: ",
            this.millisToSeconds(timingDetails[id].end - timingDetails[id].start));
    } else {
        console.error("TIMING - No reference to the function with id <" + id + ">.",);
    }
}

/*getTimings() { // TODO understood
    Object.entries(timingDetails).forEach(([id, timing,]) => {
        if (timing.end !== undefined) {
            console.debug("TIMING - Time used by function with id <" + id + "> is: ",
                this.millisToSeconds(timingDetails[id].end - timingDetails[id].start));
        }
    });
},*/

